import { Routes } from '@angular/router'
import {About} from './components/about/about'
import {Home} from './components/home/home'
import {Profile} from './components/profile/profile'
import {Projects} from './components/projects/projects'
import {Sign} from './components/sign/sign'
import {
  ABOUT_PATH,
  HOME_PATH,
  PROFILE_PATH, PROJECTS_PATH,
  SIGN_PATH
} from './general/shared'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: HOME_PATH,
    component: Home
  },
  {
    path: `${SIGN_PATH}/:projectId`,
    component: Sign
  },
  {
    path: ABOUT_PATH,
    component: About
  },
  {
    path: PROFILE_PATH,
    component: Profile
  },
  {
    path: PROJECTS_PATH,
    component: Projects
  },
  {
    path: '**',
    redirectTo: 'home'
  }
] satisfies Routes
